import Image from 'next/image';
import Link from 'next/link';
import { getEdgeUrl } from '@/lib/getEdgeUrl';

const ChristmasBanner = ({ closeMenu }: { closeMenu: () => void }) => (
  <div className="px-5 py-2.5">
    <Link href="/collections/hot-deals" onClick={closeMenu} className="group">
      <div
        className="relative flex h-[70px] items-center justify-between gap-3 rounded-lg pl-6 pr-3"
        // eslint-disable-next-line react/forbid-dom-props
        style={{
          background:
            'radial-gradient(133.38% 59.93% at 50% 49.8%, #D7394A 0%, #C84751 100%), #D63748',
        }}
      >
        <div className="absolute left-0 top-0 z-0 h-full w-full rounded-l-lg bg-cover bg-center">
          <Image
            src={getEdgeUrl('images/hot-deals/menu/christmas-banner-2025.png')}
            alt="Hot Deals"
            height={200}
            width={400}
            className="h-full w-auto rounded-l-lg"
            quality={100}
          />
        </div>
        <h3 className="z-10 text-sm font-bold text-white">Holiday Deals</h3>
        <div className="z-10 shrink-0 rounded-full bg-gray-700 px-4 py-2 text-xs font-semibold text-white group-hover:underline">
          Shop Now
        </div>
      </div>
    </Link>
  </div>
);

export default ChristmasBanner;
